import type { AxiosResponse } from "axios";
import type { Account } from "bonusx-api-main-manager";
import { useAccountQuery } from "../../api/features/account/use-account.query";
import { accountApi } from "../services/main-account-api-instance";

export const useAccountSwrKey = "account-get-me";

interface IUseAccount {
  accountData: Account | undefined;
  revalidate(): Promise<AxiosResponse<Account> | undefined>;
  loading: boolean;
  error: any;
  accountApi: typeof accountApi;
}

/**
 * @deprecated This hook is a legacy wrapper around useAccountQuery for backward compatibility.
 * New code should use useAccountQuery directly from src/api/features/account/use-account.query.ts
 */
export function useAccount(): IUseAccount {
  const query = useAccountQuery();

  async function revalidate(): Promise<AxiosResponse<Account> | undefined> {
    await query.revalidate();
    // Return undefined for backward compatibility
    // Original implementation returned AxiosResponse but callers don't use the return value
    return undefined;
  }

  return {
    accountData: query.accountData,
    revalidate,
    loading: query.loading,
    error: query.error,
    accountApi,
  };
}
